var r = /* @__PURE__ */ ((N) => (N.ROWS = "rows", N.COLUMNS = "columns", N))(r || {}), D = /* @__PURE__ */ ((N) => (N.ASCENDING = "chevron-up", N.DESCENDING = "chevron-down", N))(D || {}), E = /* @__PURE__ */ ((N) => (N.ASCENDING = "asc", N.DESCENDING = "desc", N))(E || {});
export {
  r as RocheUIMultipleAlternatives,
  D as SortIcon,
  E as SortOrder
};
